/* Footer: values band (navy 900), then logo + tagline + links. */
.footer {
  background: var(--brand-navy-900);
  color: var(--white);
}

/* Optional drifting photo strip: 64 px, tiles 180 × 64, 25% opacity, 60 s drift. */
.strip {
  position: relative;
  height: 64px;
  overflow: hidden;
  background: var(--brand-navy-950);
}

.drift {
  display: flex;
  gap: 4px;
  width: max-content;
  height: 64px;
  padding-right: 4px;
  opacity: 0.25;
  animation: drift 60s linear infinite;
  will-change: transform;
}

.drift img {
  display: block;
  flex: none;
  width: 180px;
  height: 64px;
  object-fit: cover;
}

.stripWash {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    var(--brand-navy-900) 0%,
    var(--navy-900-a45) 12%,
    var(--navy-900-a45) 88%,
    var(--brand-navy-900) 100%
  );
}

@keyframes drift {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .drift {
    animation: none !important;
  }
}

:global(html[data-motion='reduced']) .drift {
  animation: none !important;
}

.values {
  border-bottom: 1px solid var(--white-a10);
}

.valuesList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px 32px;
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 32px var(--content-gutter);
  font-size: 24px;
  letter-spacing: 0.06em;
  list-style: none;
}

.dot {
  color: var(--brand-gold);
}

/* Phone: the values wrap onto several rows, so the dots between them go. A dot left at the end of a
   row read as a stray mark (QA-018). */
@media (max-width: 720px) {
  .valuesList {
    justify-content: center;
    gap: 8px 24px;
    font-size: 20px;
  }

  .dot {
    display: none;
  }
}

.bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 24px var(--content-gutter);
}

.logo {
  display: block;
  width: auto;
  height: 28px;
}

.tagline {
  margin: 0;
  color: var(--text-on-dark-dim);
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 0 24px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.link {
  display: inline-flex;
  align-items: center;
  min-height: var(--control-height);
  padding: 0;
  border: 0;
  background: none;
  color: var(--text-on-dark-muted);
  font-family: var(--font-ui);
  font-size: 13px;
  letter-spacing: 0.1em;
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;
  transition: color var(--dur-fast) ease;
}

.link:hover,
.link[data-hovered] {
  color: var(--white);
}
